import React from "react";
import { Container } from "react-bootstrap";
import RichText from "components/rich-text";
import * as style from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";

const ImageWithText = ({ data }) => {
  const { title, image, content, bgColor, imageAlign, sectionBorderColor, alt } = data;

  return (
    <Container>
      <RichText blocks={title} className={style.title}/>
      <div className={style.mainContainer} style={{
        border: sectionBorderColor ? "1px solid" : "none",
        borderColor: sectionBorderColor ? sectionBorderColor.hex : "",
        backgroundColor: bgColor ? bgColor.hex : "",
      }}>
        <div className={`${style.content} ${imageAlign === "right" && style.reverse}`}>
          <div className={style.image}>
            <img src={getImagePath(image, true)} alt={alt} />
          </div>
          <RichText className={style.richTextWrapper} blocks={content} />
        </div>
      </div>
    </Container>
  );
};

export default ImageWithText;